// frontend/src/constants/content.js
export const portfolioSamples = [
  {
    name: "Dhaval Shah",
    type: "Executive CTO Portfolio",
    url: "https://dhavalshah.co",
    image: "https://api.microlink.io/?url=https%3A%2F%2Fdhavalshah.co&screenshot=true&meta=false&embed=screenshot.url",
    fallback: "https://images.unsplash.com/photo-1592839961515-64c68091f712?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
    signal: "Clarity. Architecture. Execution.",
  },
  {
    name: "Aarush Shah",
    type: "Engineering Research Portfolio",
    url: "https://aarushs.com",
    image: "https://api.microlink.io/?url=https%3A%2F%2Faarushs.com&screenshot=true&meta=false&embed=screenshot.url",
    fallback: "https://images.unsplash.com/photo-1706700392626-5279fb90ae73?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
    signal: "Learn. Derive. Engineer.",
  },
  {
    name: "Rujuta Shah",
    type: "Digital Construction Portfolio",
    url: "https://rujuta.co.in/",
    image: "https://api.microlink.io/?url=https%3A%2F%2Frujuta.co.in%2F&screenshot=true&meta=false&embed=screenshot.url",
    fallback: "https://images.unsplash.com/photo-1583755391669-5d4e2d1cf3d9?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
    signal: "Collaborate. Synergize. Integrate.",
  },
];

export const resumeFormats = [
  {
    title: "Executive Resume",
    tag: "Board-ready narrative",
    accent: "Practice Head",
    lines: ["25+ years enterprise technology leadership", "GenAI, blockchain, cloud architecture", "Revenue-focused digital transformation"],
  },
  {
    title: "Modern ATS Resume",
    tag: "Recruiter-scannable",
    accent: "Impact bullets",
    lines: ["Keyword-rich skills matrix", "Clean chronology", "Quantified outcomes and competencies"],
  },
  {
    title: "Creative Portfolio Resume",
    tag: "Story-led proof",
    accent: "Signal + style",
    lines: ["Career positioning statement", "Project highlights", "Portfolio site content blocks"],
  },
];

export const pricingTiers = [
  { name: "Resume Only", price: "INR 5,000", description: "For professionals who need a sharper document fast.", features: ["Psychometric interview", "Modern ATS resume", "Executive resume format", "Download-ready copy"] },
  { name: "Resume + Interview", price: "INR 30,000", description: "For candidates preparing for leadership conversations.", featured: true, features: ["Everything in Resume Only", "1-on-1 guided mock interview", "Structured feedback report", "Interview prep content"] },
  { name: "All Inclusive", price: "INR 50,000", description: "For a complete executive presence across resume and web.", features: ["Everything in Resume + Interview", "Custom portfolio website", "Domain setup guidance", "Priority delivery workflow"] },
];

export const marginalLines = [
  "Clarity scales.",
  "Structure reveals intent.",
  "What remains, matters.",
  "Understatement wins.",
  "Precision over noise.",
  "Selection, not exploration.",
  "Compress until it is true.",
  "One identity. Fully held.",
];
